import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ShopSettingsService } from '../modules/general/services/shop-settings.service';
import { ConnectionService } from '../services/connection/connection.service';

@Injectable()
export class PageMaintenanceGuard implements CanActivate {

  constructor(
    private router: Router,
    private shopSettingsService: ShopSettingsService,
    private connectionService: ConnectionService,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (!this.shopSettingsService.isMaintenanceWebshop && !this.isVuMaintenance) {
      this.router.navigate(['']);
      return false;
    }

    return true;
  }

  get isVuMaintenance(): boolean {
    return this.shopSettingsService.isVUMode && !this.connectionService.isAuthorizationTokenExist;
  }
}
